import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { type Epic } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import {
	FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES,
	updateConfluenceAccessRequestCapabilities,
} from '../actions';
import { getCloudId } from '../context/selectors';
import { type State } from '../types';
import { type Action } from 'redux';
import { getConfluenceAccessRequestCapabilities$ } from './requests';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { AccessRequestCapabilityType } from '../confluence/access-request-capabilities/types';

const LICENCE_EXCEEDED_ERROR_CODE = 'licence-exceeded';

const confluenceAccessRequestCapabilitiesEpic: Epic<Action, State> = (action$, store) =>
	action$.ofType(FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES).switchMap(() => {
		const state = store.getState();
		const cloudId = getCloudId(state);
		return getConfluenceAccessRequestCapabilities$(cloudId)
			.mergeMap((response) => {
				fetchSuccess('confluence.access-request-capabilities');
				const results = Object.values(response.results);
				// check we got exactly 1 result and the result is known, otherwise error
				if (
					results.length !== 1 ||
					!Object.values(AccessRequestCapabilityType).includes(results[0])
				) {
					return of(updateConfluenceAccessRequestCapabilities(AccessRequestCapabilityType.ERROR));
				}
				return of(updateConfluenceAccessRequestCapabilities(results[0]));
			})
			.catch((err) => {
				let shouldFireOperationalEvent = true;
				try {
					const errorMessageObject = JSON.parse(err?.message);
					// do not fire failure event if it's a 'licence-exceeded' error
					if (errorMessageObject?.code === LICENCE_EXCEEDED_ERROR_CODE) {
						shouldFireOperationalEvent = false;
						// TO-DO : Show UI toast to notify user that license is exceeded
					}
				} catch (e) {
					//Not a valid JSON, should fire failure event
					shouldFireOperationalEvent = true;
				}
				shouldFireOperationalEvent && fetchFailed('confluence.access-request-capabilities', err);
				return of(updateConfluenceAccessRequestCapabilities(AccessRequestCapabilityType.ERROR));
			});
	});

export default confluenceAccessRequestCapabilitiesEpic;
